import { SchemaItem } from "../../@shared/Models/Models";

const initialModel = {
    isShowModal: false as boolean,
    name: "" as string,
    description: "" as string,
    id: "" as string,
    schema: [] as SchemaItem[],
}

export const initialState = {
    schema: initialModel,
}

export type SchemaStateType = typeof initialState;

export type UpdateSchemaItem = { index: number } & SchemaItem